import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';

/** Mirror of backend `KpiStripPrefDTO`: the KPI tile keys the caller hid. Empty = nothing hidden. */
export interface KpiStripPrefResponse {
    hiddenKeys: string[];
}

/** The caller's own hidden KPI strip tiles, saved on the server per user and institution. */
export const KpiStripPrefService = {
    get: async (institutionId: string): Promise<KpiStripPrefResponse> => {
        const res = await axios.get(ENDPOINTS.DASHBOARD.KPI_STRIP(institutionId), { headers: AuthService.getAuthHeader() });
        return res.data;
    },

    save: async (institutionId: string, hiddenKeys: string[]): Promise<KpiStripPrefResponse> => {
        const res = await axios.put(ENDPOINTS.DASHBOARD.KPI_STRIP(institutionId), { hiddenKeys }, { headers: AuthService.getAuthHeader() });
        return res.data;
    },
};
